import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.HashedStringStore.GetHashedStringData.IRequest;
type Response = Api.HashedStringStore.GetHashedStringData.IResponse;
type Headers = Api.HashedStringStore.GetHashedStringData.IHeaders;
const url = '/api/Public/HashedStore';
export default async function publicGetHashedStringData({ hash, access_token }: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, { hash }),
    headers: { ...getDefaultHeaders(), Authorization: `Bearer ${access_token}` },
  });
}
